import { rand, randFloat, randNumber, randSentence } from '@ngneat/falso';
import { calculateTaxFromTotal, TaxRate } from '@principle-theorem/accounting';
import {
  ADA_SERVICE_CODES,
  ChartableSurface,
  IChartedItemConfiguration,
  IPricedServiceCodeEntry,
  IScopedServiceCode,
  IServiceCode,
  IServiceCodeEntry,
  ServiceCodeType,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  getEnumValues,
  MockGenerator,
  Properties,
} from '@principle-theorem/shared';
import { MockNamedDocument } from '@principle-theorem/testing';
import { v4 as uuid } from 'uuid';
import { PricingRule } from '../fees/pricing-rules/pricing-rule';

export function randomAdaCode(): IServiceCode {
  return ADA_SERVICE_CODES[
    Math.floor(Math.random() * ADA_SERVICE_CODES.length)
  ];
}

export class ServiceCodeMock
  extends BaseFirestoreMock<Properties<IServiceCode>>
  implements Properties<IServiceCode>
{
  private static _adaCode = randomAdaCode();
  claimCode = ServiceCodeMock._adaCode.code;
  rootCode = ServiceCodeMock._adaCode.code;
  fee = randFloat({ min: 1, max: 1000 });
  notes = randSentence();
  title = ServiceCodeMock._adaCode.title;
  description = ServiceCodeMock._adaCode.description;
  rules = {};
  scope = [rand(getEnumValues(ChartableSurface))];
  taxStatus = ServiceCodeMock._adaCode.taxStatus;
  code = ServiceCodeMock._adaCode.code;
  type = rand(getEnumValues(ServiceCodeType));
  extendedData = {};
  pricingRule = PricingRule.init();
}

export class ScopedServiceCodeMock
  extends ServiceCodeMock
  implements Properties<IScopedServiceCode>
{
  private static _scopedAdaCode = randomAdaCode();
  override code = ScopedServiceCodeMock._scopedAdaCode.code;
  override type = rand(getEnumValues(ServiceCodeType));
}

export class ServiceCodeEntryMock
  extends ScopedServiceCodeMock
  implements Properties<IServiceCodeEntry>
{
  quantity = randNumber({ min: 1, max: 3 });
}

export class PricedServiceCodeEntryMock
  extends ServiceCodeEntryMock
  implements Properties<IPricedServiceCodeEntry>
{
  uuid = uuid();
  price = randFloat({ min: 1, max: 1000 });
  priceOverride = randFloat({ min: 1, max: 1000 });
  tax = calculateTaxFromTotal(this.priceOverride, TaxRate.GST);
  chartedItemOrigin = MockNamedDocument<IChartedItemConfiguration>();
  chartedSurfaces = [];
}

export function MockPricedServiceCodeEntry(
  overrides?: Partial<IPricedServiceCodeEntry>
): IPricedServiceCodeEntry {
  return MockGenerator.generate(PricedServiceCodeEntryMock, {
    type: ServiceCodeType.ADA,
    quantity: 1,
    price: 10,
    priceOverride: undefined,
    ...overrides,
  });
}
